import i18next from "i18next";
import { initReactI18next } from "react-i18next";

import uzCommon from "../locales/uz/common.json";
import uzHome from "../locales/uz/home.json";
import uzWorks from "../locales/uz/works.json";
import uzOmbor from "../locales/uz/ombor.json";
import uzQarzlar from "../locales/uz/qarzlar.json";
import uzClients from "../locales/uz/clients.json";
import uzBroadcast from "../locales/uz/broadcast.json";
import uzEmployees from "../locales/uz/employees.json";
import uzReminders from "../locales/uz/reminders.json";
import uzAnalytics from "../locales/uz/analytics.json";
import uzMurojaatlar from "../locales/uz/murojaatlar.json";
import uzSettings from "../locales/uz/settings.json";
import uzLogin from "../locales/uz/login.json";

import ruCommon from "../locales/ru/common.json";
import ruHome from "../locales/ru/home.json";
import ruWorks from "../locales/ru/works.json";
import ruOmbor from "../locales/ru/ombor.json";
import ruQarzlar from "../locales/ru/qarzlar.json";
import ruClients from "../locales/ru/clients.json";
import ruBroadcast from "../locales/ru/broadcast.json";
import ruEmployees from "../locales/ru/employees.json";
import ruReminders from "../locales/ru/reminders.json";
import ruAnalytics from "../locales/ru/analytics.json";
import ruMurojaatlar from "../locales/ru/murojaatlar.json";
import ruSettings from "../locales/ru/settings.json";
import ruLogin from "../locales/ru/login.json";

export const STORAGE_KEY = "an_dashboard_lang";
export type Lang = "uz" | "ru";
export const LANGS: Lang[] = ["uz", "ru"];

export function getInitialLang(): Lang {
  if (typeof window === "undefined") return "uz";
  const saved = localStorage.getItem(STORAGE_KEY);
  return saved === "ru" || saved === "uz" ? saved : "uz";
}

export const resources = {
  uz: {
    common: uzCommon,
    home: uzHome,
    works: uzWorks,
    ombor: uzOmbor,
    qarzlar: uzQarzlar,
    clients: uzClients,
    broadcast: uzBroadcast,
    employees: uzEmployees,
    reminders: uzReminders,
    analytics: uzAnalytics,
    murojaatlar: uzMurojaatlar,
    settings: uzSettings,
    login: uzLogin,
  },
  ru: {
    common: ruCommon,
    home: ruHome,
    works: ruWorks,
    ombor: ruOmbor,
    qarzlar: ruQarzlar,
    clients: ruClients,
    broadcast: ruBroadcast,
    employees: ruEmployees,
    reminders: ruReminders,
    analytics: ruAnalytics,
    murojaatlar: ruMurojaatlar,
    settings: ruSettings,
    login: ruLogin,
  },
} as const;

i18next.use(initReactI18next).init({
  resources,
  lng: getInitialLang(),
  fallbackLng: "uz",
  defaultNS: "common",
  ns: Object.keys(resources.uz),
  interpolation: { escapeValue: false },
  returnNull: false,
});

i18next.on("languageChanged", (lng) => {
  if (typeof window !== "undefined") {
    localStorage.setItem(STORAGE_KEY, lng);
    document.documentElement.setAttribute("lang", lng);
  }
});

if (typeof window !== "undefined") {
  document.documentElement.setAttribute("lang", getInitialLang());
}

export default i18next;
